import { render, staticRenderFns } from "./AssembliesInsights.vue?vue&type=template&id=36bae2d2&"
import script from "./AssembliesInsights.vue?vue&type=script&lang=js&"
export * from "./AssembliesInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VDivider,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36bae2d2')) {
      api.createRecord('36bae2d2', component.options)
    } else {
      api.reload('36bae2d2', component.options)
    }
    module.hot.accept("./AssembliesInsights.vue?vue&type=template&id=36bae2d2&", function () {
      api.rerender('36bae2d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equipment/components/AssembliesInsights.vue"
export default component.exports